import request from '@/utils/request'


// 新增【线索客户】
export function uploadFile(data) {
    return request({
      url: '/common/upload',
      method: 'post',
      data: data
    })
  }

// 删除文件
export function deleteFile(data) {
  return request({
    url: '/common/delete',
    method: 'delete',
    data: data
  })
}

  // 删除ucloud服务器对象存储文件
  export function deleteFileToUcloud(data) {
    return request({
      url: '/common/ucloud/delete',
      method: 'delete',
      data: data
    })
  }


//  上传文件到ucloud服务器对象存储接口中
export function ucloudUpFileToContract(data) {
  return request({
    url: '/common/ucloud/upload/contract',
    method: 'post',
    data: data
  })
}
